import * as types from '../constants/outstandingOrderConstants';
import * as activitType from '../constants/activityConstants'

export function loadoutstandingOrder() {
  return {
 type: types.LOAD_OUTSTANDING_ORDER, 
  };
 }
 export function changeCmdyPair(cmdyPair, currentId, layout) {
   return {
     type: types.CHANGE_COMMDTY,
     cmdyPair,
     currentId,
     layout
   };
 }
 export function getAllBenchMark(){
     return {
        type: types.GET_ALL_BM,
        promise: (client) => client.get('/GetAllBenchmarksTrd', {})
     };
 }
 export function getAllOrdersTrd(AC){
  const user = JSON.parse(localStorage.getItem('user'));
  const sid =  user.SID;
    return {
       type: activitType.GET_ALL_ORDER_DATA,
       promise: (client) => client.get(`/getOrdersDataTrd?sid=${sid}&trade_type=A&AC=${AC}`)

       };
}
export function getTrdBook(){
  const user = JSON.parse(localStorage.getItem('user'));
  const sid =  user.SID;
    return {
       type: activitType.GET_TRADEBOOK_DATA, 
       promise: (client) => client.get(`/getOrdersDataTrd?sid=${sid}&trade_type=D&AC=""`)
       };
}
export function getOrderBook(){
  const user = JSON.parse(localStorage.getItem('user'));
  const sid =  user.SID;
  const AC = JSON.parse(localStorage.getItem('DFA')).C;
    return {
       type: activitType.GET_ORDERBOOK_DATA, 
       promise: (client) => client.get(`/getOrdersDataTrd?sid=${sid}&trade_type=O&AC=${AC}`)
       };
}
export function getFixingOrder(){
  const user = JSON.parse(localStorage.getItem('user'));
  const sid =  user.SID;
  const AC = JSON.parse(localStorage.getItem('DFA')).C;
    return {
       type: activitType.GET_FIXINGORDER_DATA, 
       promise: (client) => client.get(`/getOrdersDataTrd?sid=${sid}&trade_type=F&AC=${AC}`)
       };
}
export function closeLmtModifypopup(flag) {
  return {
    type: types.LOAD_LMTMODIFYPOPUP_FLAG,
     flag
   };
}

export function getOpenTrdes(){
  const user = JSON.parse(localStorage.getItem('user'));
  const sid =  user.SID;
  const AC = JSON.parse(localStorage.getItem('DFA')).C;
    return {
       type: activitType.GET_OPENTRADES_DATA, 
       promise: (client) => client.get(`/getOrdersDataTrd?sid=${sid}&trade_type=OPT&AC=${AC}`)
       };
}
export function closeOpnTrdModifypopup(flag) {
  return {
    type: types.LOAD_OPENTRADEMODIFYPOPUP_FLAG,
     flag
   };
}
export function closeOpnTrdAllctMdl(flag) {
  return {
    type: activitType.LOAD_OPENTRADEALLOCATE_FLAG,
     flag
   };
}
export function allocateQuantity(alocType,account,location,docNo,dealType,linkDocSN,userID,linkDocData) {
  var obj={};
  obj.AC=account;
  obj.BTO=location;
  obj.FromDN=docNo;
  // obj.DT=dealType;
  obj.FromDocSN=linkDocSN;
  obj.userId=userID;
  obj.ToDoctype=alocType==="F"?"FNC":dealType===0?"TIS":"TRS";
  obj.allocData=linkDocData;
   obj.isPhysicalAlloc=(alocType === "P"?true : false)
  // console.log(JSON.stringify(obj));
  return {
    type: types.ALLOCATE_QUANTITY, 
    promise: (client) => client.post('/saveFixingAllocation',{
    data: obj
    }),
  };
}
export function getPhysicalsRecord(account,dealType,IID) {
  var obj={};
  obj.AC=account;
  obj.DT=dealType;
  obj.IID=IID;
  return {
    type: types.GET_PHYSICALS, 
    promise: (client) => client.get(`/getPhysicalTradeList?AC=${account}&DT=${dealType}&IID=${IID}`),
  };
}
export function closeFixModifypopup(flag) {
  return {
    type: types.LOAD_FIXMODIFYPOPUP_FLAG,
     flag
   };
}
//close open trade quantity alert popup. 
export function closeQtyAlertPopup(flag){
  let message = 'closePopup';
  return {
    type: activitType.SHOW_OPENTRADE_ALERT,
     flag,message
   };
}
